module.exports = "<div class=\"system-info-wrapper\">\n  Todos los derechos reservados - Ministerio del Ambiente - 2019\n</div>\n"